import QuizContainer from './QuizContainer';

/*
* 문제가 들어있는 카드
*/
export default QuizContainer;